/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { Divider, Skeleton } from '@mui/material';

import { ClusterStates, Endpoints, Infer } from 'shared';

import { PriceEstimation } from '../../../../../../components/PriceEstimation/PriceEstimation';
import { useSystemConfig } from '../../../../../../providers/SystemConfigProvider';
import { UpdateClusterDetailsParameterIdentification } from '../../../../../../types/cluster/UpdateClusterDetailsParameterIdentification';

type IProps = {
  cluster: Infer<typeof Endpoints.GetCluster>['Response'][200];
  status: Infer<typeof Endpoints.GetClusterStatus>['Response'][200];
  identificationData: UpdateClusterDetailsParameterIdentification;
};

export const PlanTabContent = memo<{
  cluster: IProps['cluster'];
  status: ClusterStates | undefined;
  currentConfig: any;
}>(({ cluster, status, currentConfig }) => {
  const systemConfig = useSystemConfig();

  return status && currentConfig && systemConfig ? (
    <PriceEstimation
      cpuUnits={currentConfig.cpuUnits}
      memoryGbs={currentConfig.memoryGbs}
      storageGbs={currentConfig.storageGbs}
      replicas={currentConfig.replicas}
      supportPlan={currentConfig.supportPlan}
      serviceType={cluster.type}
    />
  ) : (
    <>
      <Skeleton variant="rounded" sx={{ margin: '17px 0' }} />
      <Skeleton variant="rounded" height={87} />
      <Skeleton variant="rounded" sx={{ margin: '17px 0' }} />
      <Skeleton variant="rounded" height={87} />
      <Divider sx={{ mt: '20px' }} />
      <Skeleton variant="rounded" sx={{ mt: '25px' }} />
    </>
  );
});
